/* Unified NorDerm FAQ injector.
   Source of truth for FAQ markup is partials/faq.html.
   Includes an inline fallback so file:// previews still work.
*/
(function(){
  var PARTIAL_URL = 'partials/faq.html';
  var FALLBACK_HTML = "<section class=\"main1513-faq main1513-mobile-faq-402\" data-node-id=\"403:2049\" aria-label=\"FAQ\">\n  <div class=\"main1513-faq-head main1513-mobile-faq-head-402\">\n    <p class=\"main1513-label\">FAQ</p>\n    <h2>Alt du trenger å vite før din <em>første</em> bestilling</h2>\n  </div>\n  <div class=\"main1513-faq-list faq-list-long main1513-mobile-faq-list-402\" data-node-id=\"403:1879\">\n    <article class=\"faq-item\">\n      <button class=\"faq-question\" type=\"button\" aria-expanded=\"false\">\n        <span class=\"faq-mark\"><svg viewBox=\"0 0 24 24\"><path class=\"faq-mark-h\" d=\"M5 12h14\"/><path class=\"faq-mark-v\" d=\"M12 5v14\"/></svg></span>\n        <span>Trenger jeg en konto for å bestille?</span>\n      </button>\n      <div class=\"faq-answer\"><p>Ja. NorDerm er forbeholdt lisensierte klinikker og behandlere. Registrer deg, så godkjenner vi kontoen din innen 1–2 virkedager.</p></div>\n    </article>\n    <article class=\"faq-item\">\n      <button class=\"faq-question\" type=\"button\" aria-expanded=\"false\">\n        <span class=\"faq-mark\"><svg viewBox=\"0 0 24 24\"><path class=\"faq-mark-h\" d=\"M5 12h14\"/><path class=\"faq-mark-v\" d=\"M12 5v14\"/></svg></span>\n        <span>Hvor rask er leveringen?</span>\n      </button>\n      <div class=\"faq-answer\"><p>Bestillinger lagt før kl. 14:00 sendes samme dag fra lageret i Stavanger og leveres normalt neste arbeidsdag i hele Norge.</p></div>\n    </article>\n    <article class=\"faq-item\">\n      <button class=\"faq-question\" type=\"button\" aria-expanded=\"false\">\n        <span class=\"faq-mark\"><svg viewBox=\"0 0 24 24\"><path class=\"faq-mark-h\" d=\"M5 12h14\"/><path class=\"faq-mark-v\" d=\"M12 5v14\"/></svg></span>\n        <span>Er alle produkter CE-godkjente?</span>\n      </button>\n      <div class=\"faq-answer\"><p>Ja. Alle produkter i katalogen er CE-godkjente, med sertifikat, LOT-nummer og utløpsdato tilgjengelig direkte på produktsiden.</p></div>\n    </article>\n    <article class=\"faq-item\">\n      <button class=\"faq-question\" type=\"button\" aria-expanded=\"false\">\n        <span class=\"faq-mark\"><svg viewBox=\"0 0 24 24\"><path class=\"faq-mark-h\" d=\"M5 12h14\"/><path class=\"faq-mark-v\" d=\"M12 5v14\"/></svg></span>\n        <span>Hvilke betalingsmetoder aksepterer dere?</span>\n      </button>\n      <div class=\"faq-answer\"><p>Vi tilbyr faktura med 14 dagers betalingsfrist for godkjente klinikker, samt kort og Vipps ved bestilling.</p></div>\n    </article>\n    <article class=\"faq-item\">\n      <button class=\"faq-question\" type=\"button\" aria-expanded=\"false\">\n        <span class=\"faq-mark\"><svg viewBox=\"0 0 24 24\"><path class=\"faq-mark-h\" d=\"M5 12h14\"/><path class=\"faq-mark-v\" d=\"M12 5v14\"/></svg></span>\n        <span>Hva er returvilkårene?</span>\n      </button>\n      <div class=\"faq-answer\"><p>Uåpnede produkter kan returneres innen 14 dager. Av hensyn til pasientsikkerhet kan åpnede sterile produkter ikke returneres.</p></div>\n    </article>\n  </div>\n</section>\r\n";

  function syncItem(item){
    var isOpen = item.classList.contains('open');
    var button = item.querySelector('.faq-question');
    if(button){
      button.setAttribute('aria-expanded', String(isOpen));
    }
    /* Visual plus->minus morph is pure CSS now (.faq-item.open .faq-mark-v),
       no JS attribute swap needed — that used to snap instantly since a `d`
       attribute change can't be interpolated. */
  }

  function closeItem(item){
    item.classList.remove('open');
    syncItem(item);
  }

  function openItem(item, items){
    items.forEach(function(otherItem){
      if(otherItem !== item) closeItem(otherItem);
    });
    item.classList.add('open');
    syncItem(item);
  }

  function initFaqSections(root){
    var sections = root.querySelectorAll('.main1513-faq, .faq-list-long, .faq-list');
    sections.forEach(function(section){
      if(section.dataset.nordermFaqReady === '1') return;
      var items = Array.from(section.querySelectorAll('.faq-item'));
      if(!items.length) return;
      section.dataset.nordermFaqReady = '1';

      items.forEach(function(item){
        syncItem(item);
        var button = item.querySelector('.faq-question');
        if(!button || button.dataset.nordermFaqBound === '1') return;
        button.dataset.nordermFaqBound = '1';
        button.addEventListener('click', function(event){
          event.preventDefault();
          event.stopImmediatePropagation();
          if(item.classList.contains('open')){
            closeItem(item);
          }else{
            openItem(item, items);
          }
        }, true);
      });
    });
  }

  function inject(html){
    var placeholders = document.querySelectorAll('[data-norderm-faq]');
    if(!placeholders.length){
      initFaqSections(document);
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = (html || FALLBACK_HTML).trim();
    var template = wrapper.firstElementChild;
    if(!template){
      initFaqSections(document);
      return;
    }

    placeholders.forEach(function(placeholder){
      placeholder.replaceWith(template.cloneNode(true));
    });

    initFaqSections(document);
  }

  function load(){
    if(document.querySelector('[data-norderm-faq]') && location.protocol !== 'file:'){
      try{
        fetch(PARTIAL_URL, {cache:'no-cache'})
          .then(function(response){ return response.ok ? response.text() : null; })
          .then(function(html){ inject(html || FALLBACK_HTML); })
          .catch(function(){ inject(FALLBACK_HTML); });
        return;
      }catch(error){
        inject(FALLBACK_HTML);
        return;
      }
    }

    if(location.protocol === 'file:'){
      inject(FALLBACK_HTML);
      return;
    }

    initFaqSections(document);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', load);
  }else{
    load();
  }
})();
